import styled from 'styled-components';

export const Container = styled.div`

`;

export const ContainerAddress = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-direction: column;

  width: 100%;
  height: 100%;
`;

export const ContainerAddressList = styled.div`
  width: 100%;
`;

export const AddressCreatedButton = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    width: 130px;
    height: 30px;
    border: 1px solid var(--primary);
    border-radius: 8px;
    transition:all 0.6s ease;
    cursor: pointer;

    span{
      text-align: center;
    }

    :hover{
      background-color: var(--primary);

      span {
        color: #FFF;
      }
    }
`;

export const ContainerAddressRow = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;

  width: 100%;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid var(--primary);
  margin-bottom: 10px;
  transition:all 0.8s ease;

  :hover{
      background-color: var(--primary);

      span {
        color: #FFF;
      }

      p {
        color: #FFF;
      }

      svg{
        color: #FFF;

      }
    }
    cursor: pointer;
`;

export const AddressSelButton = styled.div`
  cursor: pointer;
  margin-right: 15px;

`;

export const AddressName = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;

  width: 180px;
  margin-right: 15px;

`;


export const AddressAddress = styled.div`

`;
